import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=571a053d&scoped=true&lang=pug&"
import script from "./ProductDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProductDisplay.vue?vue&type=style&index=0&id=571a053d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a053d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571a053d')) {
      api.createRecord('571a053d', component.options)
    } else {
      api.reload('571a053d', component.options)
    }
    module.hot.accept("./ProductDisplay.vue?vue&type=template&id=571a053d&scoped=true&lang=pug&", function () {
      api.rerender('571a053d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductDisplay.vue"
export default component.exports